import React, { useContext, useEffect, useState } from "react";
import "./style.css";
import palmJumeirah from "../../Assets/icons/Palm Jumeirah.png";
import bluewaters from "../../Assets/icons/Blue.png";
import downtown from "../../Assets/icons/Downtown.png";
import marina from "../../Assets/icons/marina.png";
import palm from "../../Assets/icons/Vector Palm.png";
import { DataContext } from "../../Context/Context";
import { Link, useLocation } from "react-router-dom";
import axios from "axios";
import DynamicSeoPage from "../DynamicSeoPage";

const Properties = () => {
  const location = useLocation();
  const { listings, setListings } = useContext(DataContext);
  const [loading, setLoading] = useState(false);

  const [section, setSection] = useState({});

  useEffect(() => {
    if (location.hash) {
      const scrollToElement = () => {
        const element = document.querySelector(location.hash);
        if (element) {
          const topPosition =
            element.getBoundingClientRect().top + window.scrollY;
          window.scrollTo({
            top: topPosition,
            behavior: "smooth",
          });
        } else {
        }
      };
      setTimeout(scrollToElement, 100);
    }
  }, [location]);

  // Fetch section data for the properties banner
  const fetchSection = async () => {
    try {
      const response = await axios.get(
        `https://365luxuryhomes.com/api/sections/properties`,
      );

      if (response.data) {
        setSection(response.data);
      } else {
      }
    } catch (error) {}
  };

  useEffect(() => {
    fetchSection();
  }, []);

  // Fetch listings
  useEffect(() => {
    const fetchListings = async () => {
      setLoading(true);

      try {
        const listingsResponse = await axios.get(
          "https://365luxuryhomes.com/api/listings",
        );
        setListings(listingsResponse?.data || []);
        setLoading(false);
      } catch (error) {
        setLoading(false);
      } finally {
        setLoading(false);
      }
    };

    fetchListings();
  }, [setListings]);

  const truncateDescription = (description, wordLimit) => {
    const words = description.split(" ");
    if (words.length > wordLimit) {
      return words?.slice(0, wordLimit).join(" ") + "...";
    }
    return description;
  };

  const locations = [
    ...new Set(
      listings
        .map((listing) => listing?.listingTags?.[0]?.name)
        .filter(Boolean),
    ),
  ];

  return (
    <div>
      <DynamicSeoPage
        page="properties"
        defalut={"Properties - 365 Luxury Homes"}
      />
      <section
        className="properties_banner pt-20 pb-10"
        id="banner"
        loading="lazy"
        style={{
          backgroundImage: `url(${section?.imageUrl || ""})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="container h-full flex items-end"></div>
      </section>

      <div className="lg:mt-10 md:mt-8 mt-5">
        <div className="container flex items-center justify-between ">
          <div className="flex items-center gap-1">
            <h1 className="lg:text-xl md:text-[18px] text-[16px] font-medium leading-none text-[#74716d]">
              <span>{listings?.length}</span>
              <span> Properties found</span>
            </h1>
          </div>
          <Link
            to={"/short-term-rentels"}
            className="px-6 py-2 text-[16px] bg-[#aca9a5] hover:bg-[#6c675b] text-white hover:text-white focus:text-white active:text-white hover:no-underline inline-flex items-center justify-center h-[50px] rounded-md"
          >
            View on map
          </Link>
        </div>
      </div>
      {/* Section for Palm Jumeirah */}
      {/* <section className="py-10 pt-10 bg-white" id="palm_jumeirah">
        <div className="container">
          <div className="flex items-center gap-4 mb-16">
            <img src={palmJumeirah} alt="" className="w-10" />
            <h2 className="text-[#74716d] font-thin lg:text-2xl md:text-2xl text-xl uppercase">
              Palm Jumeirah
            </h2>
          </div>
          <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-10">
            {loading ? (
              <>
                <div className="flex w-full flex-col gap-4">
                  <div className="skeleton h-32 w-full"></div>
                  <div className="skeleton h-4 w-28"></div>
                  <div className="skeleton h-4 w-full"></div>
                  <div className="skeleton h-4 w-full"></div>
                </div>
                <div className="flex w-full flex-col gap-4">
                  <div className="skeleton h-32 w-full"></div>
                  <div className="skeleton h-4 w-28"></div>
                  <div className="skeleton h-4 w-full"></div>
                  <div className="skeleton h-4 w-full"></div>
                </div>
                <div className="flex w-full flex-col gap-4">
                  <div className="skeleton h-32 w-full"></div>
                  <div className="skeleton h-4 w-28"></div>
                  <div className="skeleton h-4 w-full"></div>
                  <div className="skeleton h-4 w-full"></div>
                </div>
              </>
            ) : (
              <>
                {listings
                  .filter(
                    (listing) =>
                      listing?.listingTags[0]?.name === "Palm Jumeirah"
                  )
                  .map((listing) => (
                    <Link
                      to={`/listing/${listing.id}`}
                      key={listing?.id}
                      className="hover:no-underline"
                    >
                      <img
                        src={`https://365luxuryhomes.com/api/listings/image?url=${encodeURIComponent(
                          listing?.listingImages[0]?.url
                        )}&w=400&q=70&format=webp`}
                        // src={listing?.listingImages[0]?.url}
                        alt=""
                        loading="lazy"
                        className="mb-4 shadow-lg w-full rounded-lg md:h-64 object-cover"
                      />
                      <div>
                        <h3 className="leading-[26px] font-normal text-[#74716d] text-[18px]">
                          {listing?.name}
                        </h3>
                        <p className="mt-2 font-thin text-[16px] text-[#74716d] leading-snug">
                          {truncateDescription(listing?.description, 12)}
                        </p>
                      </div>
                    </Link>
                  ))}
              </>
            )}
          </div>
        </div>
      </section> */}

      {/* Section for Bluewaters Island */}
      {/* <section className="py-10 pt-20 bg-[#fdfcf5]" id="bluewaters_island">
        <div className="container">
          <div className="flex items-center gap-4 mb-16">
            <img src={bluewaters} alt="" className="w-10" />
            <h2 className="text-[#74716d] font-thin lg:text-2xl md:text-2xl text-xl uppercase">
              Bluewaters Island
            </h2>
          </div>
          <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-10">
            {loading ? (
              <>
                <div className="flex w-full flex-col gap-4">
                  <div className="skeleton h-32 w-full"></div>
                  <div className="skeleton h-4 w-28"></div>
                  <div className="skeleton h-4 w-full"></div>
                  <div className="skeleton h-4 w-full"></div>
                </div>
                <div className="flex w-full flex-col gap-4">
                  <div className="skeleton h-32 w-full"></div>
                  <div className="skeleton h-4 w-28"></div>
                  <div className="skeleton h-4 w-full"></div>
                  <div className="skeleton h-4 w-full"></div>
                </div>
                <div className="flex w-full flex-col gap-4">
                  <div className="skeleton h-32 w-full"></div>
                  <div className="skeleton h-4 w-28"></div>
                  <div className="skeleton h-4 w-full"></div>
                  <div className="skeleton h-4 w-full"></div>
                </div>
              </>
            ) : (
              listings
                .filter(
                  (listing) =>
                    listing?.listingTags[0]?.name === "Bluewaters Island"
                )
                .map((listing) => (
                  <Link
                    to={`/listing/${listing.id}`}
                    key={listing?.id}
                    className="hover:no-underline"
                  >
                    <img
                      src={`https://365luxuryhomes.com/api/listings/image?url=${encodeURIComponent(
                        listing?.listingImages[0]?.url
                      )}&w=400&q=70&format=webp`}
                      alt=""
                      loading="lazy"
                      className="mb-4 shadow-lg w-full rounded-lg md:h-64 object-cover"
                    />
                    <div>
                      <h3 className="leading-[26px] font-normal text-[#74716d] text-[18px]">
                        {listing?.name}
                      </h3>
                      <p className="mt-2 font-thin text-[16px] text-[#74716d] leading-snug">
                        {truncateDescription(listing?.description, 12)}
                      </p>
                    </div>
                  </Link>
                ))
            )}
          </div>
        </div>
      </section> */}

      {/* Section for JBR */}
      {/* <section className="py-10 pt-20 bg-[#fff]" id="j_b_r">
        <div className="container">
          <div className="flex items-center gap-4 mb-16">
            <img src={palm} alt="" className="w-10" />
            <h2 className="text-[#74716d] font-thin lg:text-2xl md:text-2xl text-xl uppercase">
              JUMEIRAH BEACH RESIDENCE (JBR)
            </h2>
          </div>
          <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-10">
            {loading ? (
              <>
                <div className="flex w-full flex-col gap-4">
                  <div className="skeleton h-32 w-full"></div>
                  <div className="skeleton h-4 w-28"></div>
                  <div className="skeleton h-4 w-full"></div>
                  <div className="skeleton h-4 w-full"></div>
                </div>
                <div className="flex w-full flex-col gap-4">
                  <div className="skeleton h-32 w-full"></div>
                  <div className="skeleton h-4 w-28"></div>
                  <div className="skeleton h-4 w-full"></div>
                  <div className="skeleton h-4 w-full"></div>
                </div>
                <div className="flex w-full flex-col gap-4">
                  <div className="skeleton h-32 w-full"></div>
                  <div className="skeleton h-4 w-28"></div>
                  <div className="skeleton h-4 w-full"></div>
                  <div className="skeleton h-4 w-full"></div>
                </div>
              </>
            ) : (
              listings
                .filter((listing) => listing?.listingTags[0]?.name === "JBR")
                .map((listing) => (
                  <Link
                    to={`/listing/${listing.id}`}
                    key={listing?.id}
                    className="hover:no-underline"
                  >
                    <img
                      src={`https://365luxuryhomes.com/api/listings/image?url=${encodeURIComponent(
                        listing?.listingImages[0]?.url
                      )}&w=400&q=70&format=webp`}
                      alt=""
                      loading="lazy"
                      className="mb-4 shadow-lg w-full rounded-lg md:h-64 object-cover"
                    />
                    <div>
                      <h3 className="leading-[26px] font-normal text-[#74716d] text-[18px]">
                        {listing?.name}
                      </h3>
                      <p className="mt-2 font-thin text-[16px] text-[#74716d] leading-snug">
                        {truncateDescription(listing?.description, 12)}
                      </p>
                    </div>
                  </Link>
                ))
            )}
          </div>
        </div>
      </section> */}

      {/* Section for Downtown */}
      {/* <section className="py-10 pt-20 bg-[#fdfcf5]" id="downtown">
        <div className="container">
          <div className="flex items-center gap-4 mb-16">
            <img src={downtown} alt="" className="w-10" />
            <h2 className="text-[#74716d] font-thin lg:text-2xl md:text-2xl text-xl uppercase">
              Downtown
            </h2>
          </div>
          <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-10">
            {loading ? (
              <>
                <div className="flex w-full flex-col gap-4">
                  <div className="skeleton h-32 w-full"></div>
                  <div className="skeleton h-4 w-28"></div>
                  <div className="skeleton h-4 w-full"></div>
                  <div className="skeleton h-4 w-full"></div>
                </div>
                <div className="flex w-full flex-col gap-4">
                  <div className="skeleton h-32 w-full"></div>
                  <div className="skeleton h-4 w-28"></div>
                  <div className="skeleton h-4 w-full"></div>
                  <div className="skeleton h-4 w-full"></div>
                </div>
                <div className="flex w-full flex-col gap-4">
                  <div className="skeleton h-32 w-full"></div>
                  <div className="skeleton h-4 w-28"></div>
                  <div className="skeleton h-4 w-full"></div>
                  <div className="skeleton h-4 w-full"></div>
                </div>
              </>
            ) : (
              listings
                .filter(
                  (listing) => listing?.listingTags[0]?.name === "Downtown"
                )
                .map((listing) => (
                  <Link
                    to={`/listing/${listing.id}`}
                    key={listing?.id}
                    className="hover:no-underline"
                  >
                    <img
                      src={`https://365luxuryhomes.com/api/listings/image?url=${encodeURIComponent(
                        listing?.listingImages[0]?.url
                      )}&w=400&q=70&format=webp`}
                      alt=""
                      loading="lazy"
                      className="mb-4 shadow-lg w-full rounded-lg md:h-64 object-cover"
                    />
                    <div>
                      <h3 className="leading-[26px] font-normal text-[#74716d] text-[18px]">
                        {listing?.name}
                      </h3>
                      <p className="mt-2 font-thin text-[16px] text-[#74716d] leading-snug">
                        {truncateDescription(listing?.description, 12)}
                      </p>
                    </div>
                  </Link>
                ))
            )}
          </div>
        </div>
      </section> */}

      {/* Section for Dubai Marina*/}
      {/* <section className="py-10 pt-20 bg-[#fff]" id="dubai_marina">
        <div className="container">
          <div className="flex items-center gap-4 mb-16">
            <img src={marina} alt="" className="w-10" />
            <h2 className="text-[#74716d] font-thin lg:text-2xl md:text-2xl text-xl uppercase">
              Dubai Marina
            </h2>
          </div>
          <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-10">
            {loading ? (
              <>
                <div className="flex w-full flex-col gap-4">
                  <div className="skeleton h-32 w-full"></div>
                  <div className="skeleton h-4 w-28"></div>
                  <div className="skeleton h-4 w-full"></div>
                  <div className="skeleton h-4 w-full"></div>
                </div>
                <div className="flex w-full flex-col gap-4">
                  <div className="skeleton h-32 w-full"></div>
                  <div className="skeleton h-4 w-28"></div>
                  <div className="skeleton h-4 w-full"></div>
                  <div className="skeleton h-4 w-full"></div>
                </div>
                <div className="flex w-full flex-col gap-4">
                  <div className="skeleton h-32 w-full"></div>
                  <div className="skeleton h-4 w-28"></div>
                  <div className="skeleton h-4 w-full"></div>
                  <div className="skeleton h-4 w-full"></div>
                </div>
              </>
            ) : (
              listings
                .filter(
                  (listing) => listing?.listingTags[0]?.name === "Dubai Marina"
                )
                .map((listing) => (
                  <Link
                    to={`/listing/${listing.id}`}
                    key={listing?.id}
                    className="hover:no-underline"
                  >
                    <img
                      src={`https://365luxuryhomes.com/api/listings/image?url=${encodeURIComponent(
                        listing?.listingImages[0]?.url
                      )}&w=400&q=70&format=webp`}
                      alt=""
                      loading="lazy"
                      className="mb-4 shadow-lg w-full rounded-lg md:h-64 object-cover"
                    />
                    <div>
                      <h3 className="leading-[26px] font-normal text-[#74716d] text-[18px]">
                        {listing?.name}
                      </h3>
                      <p className="mt-2 font-thin text-[16px] text-[#74716d] leading-snug">
                        {truncateDescription(listing?.description, 12)}
                      </p>
                    </div>
                  </Link>
                ))
            )}
          </div>
        </div>
      </section> */}

      {/* Section for Emaar Beachfront*/}
      {/* <section className="py-10 pt-20 bg-[#fff]" id="emaar_beachfront">
        <div className="container">
          <div className="flex items-center gap-4 mb-16">
            <img src={marina} alt="" className="w-10" />
            <h2 className="text-[#74716d] font-thin lg:text-2xl md:text-2xl text-xl uppercase">
              Emaar Beachfront
            </h2>
          </div>
          <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-10">
            {loading ? (
              <>
                <div className="flex w-full flex-col gap-4">
                  <div className="skeleton h-32 w-full"></div>
                  <div className="skeleton h-4 w-28"></div>
                  <div className="skeleton h-4 w-full"></div>
                  <div className="skeleton h-4 w-full"></div>
                </div>
                <div className="flex w-full flex-col gap-4">
                  <div className="skeleton h-32 w-full"></div>
                  <div className="skeleton h-4 w-28"></div>
                  <div className="skeleton h-4 w-full"></div>
                  <div className="skeleton h-4 w-full"></div>
                </div>
                <div className="flex w-full flex-col gap-4">
                  <div className="skeleton h-32 w-full"></div>
                  <div className="skeleton h-4 w-28"></div>
                  <div className="skeleton h-4 w-full"></div>
                  <div className="skeleton h-4 w-full"></div>
                </div>
              </>
            ) : (
              listings
                .filter((listing) => listing?.listingTags[0]?.name === "EBF")
                .map((listing) => (
                  <Link
                    to={`/listing/${listing.id}`}
                    key={listing?.id}
                    className="hover:no-underline"
                  >
                    <img
                      src={`https://365luxuryhomes.com/api/listings/image?url=${encodeURIComponent(
                        listing?.listingImages[0]?.url
                      )}&w=400&q=70&format=webp`}
                      alt=""
                      loading="lazy"
                      className="mb-4 shadow-lg w-full rounded-lg md:h-64 object-cover"
                    />
                    <div>
                      <h3 className="leading-[26px] font-normal text-[#74716d] text-[18px]">
                        {listing?.name}
                      </h3>
                      <p className="mt-2 font-thin text-[16px] text-[#74716d] leading-snug">
                        {truncateDescription(listing?.description, 12)}
                      </p>
                    </div>
                  </Link>
                ))
            )}
          </div>
        </div>
      </section> */}

      {/* Section for District One*/}
      {/* <section className="py-10 pt-20 bg-[#fff]" id="district_one">
        <div className="container">
          <div className="flex items-center gap-4 mb-16">
            <img src={marina} alt="" className="w-10" />
            <h2 className="text-[#74716d] font-thin lg:text-2xl md:text-2xl text-xl uppercase">
              District One
            </h2>
          </div>
          <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-10">
            {loading ? (
              <>
                <div className="flex w-full flex-col gap-4">
                  <div className="skeleton h-32 w-full"></div>
                  <div className="skeleton h-4 w-28"></div>
                  <div className="skeleton h-4 w-full"></div>
                  <div className="skeleton h-4 w-full"></div>
                </div>
                <div className="flex w-full flex-col gap-4">
                  <div className="skeleton h-32 w-full"></div>
                  <div className="skeleton h-4 w-28"></div>
                  <div className="skeleton h-4 w-full"></div>
                  <div className="skeleton h-4 w-full"></div>
                </div>
                <div className="flex w-full flex-col gap-4">
                  <div className="skeleton h-32 w-full"></div>
                  <div className="skeleton h-4 w-28"></div>
                  <div className="skeleton h-4 w-full"></div>
                  <div className="skeleton h-4 w-full"></div>
                </div>
              </>
            ) : (
              listings
                .filter(
                  (listing) => listing?.listingTags[0]?.name === "District One"
                )
                .map((listing) => (
                  <Link
                    to={`/listing/${listing.id}`}
                    key={listing?.id}
                    className="hover:no-underline"
                  >
                    <img
                      src={`https://365luxuryhomes.com/api/listings/image?url=${encodeURIComponent(
                        listing?.listingImages[0]?.url
                      )}&w=400&q=70&format=webp`}
                      alt=""
                      loading="lazy"
                      className="mb-4 shadow-lg w-full rounded-lg md:h-64 object-cover"
                    />
                    <div>
                      <h3 className="leading-[26px] font-normal text-[#74716d] text-[18px]">
                        {listing?.name}
                      </h3>
                      <p className="mt-2 font-thin text-[16px] text-[#74716d] leading-snug">
                        {truncateDescription(listing?.description, 12)}
                      </p>
                    </div>
                  </Link>
                ))
            )}
          </div>
        </div>
      </section> */}

      {/* Section for JVC*/}
      {/* <section className="py-10 pt-20 bg-[#fff]" id="j_v_c">
        <div className="container">
          <div className="flex items-center gap-4 mb-16">
            <img src={marina} alt="" className="w-10" />
            <h2 className="text-[#74716d] font-thin lg:text-2xl md:text-2xl text-xl uppercase">
              Jumeirah Village Circle (JVC)
            </h2>
          </div>
          <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-10">
            {loading ? (
              <>
                <div className="flex w-full flex-col gap-4">
                  <div className="skeleton h-32 w-full"></div>
                  <div className="skeleton h-4 w-28"></div>
                  <div className="skeleton h-4 w-full"></div>
                  <div className="skeleton h-4 w-full"></div>
                </div>
                <div className="flex w-full flex-col gap-4">
                  <div className="skeleton h-32 w-full"></div>
                  <div className="skeleton h-4 w-28"></div>
                  <div className="skeleton h-4 w-full"></div>
                  <div className="skeleton h-4 w-full"></div>
                </div>
                <div className="flex w-full flex-col gap-4">
                  <div className="skeleton h-32 w-full"></div>
                  <div className="skeleton h-4 w-28"></div>
                  <div className="skeleton h-4 w-full"></div>
                  <div className="skeleton h-4 w-full"></div>
                </div>
              </>
            ) : (
              listings
                .filter((listing) => listing?.listingTags[0]?.name === "JVC")
                .map((listing) => (
                  <Link
                    to={`/listing/${listing.id}`}
                    key={listing?.id}
                    className="hover:no-underline"
                  >
                    <img
                      src={`https://365luxuryhomes.com/api/listings/image?url=${encodeURIComponent(
                        listing?.listingImages[0]?.url
                      )}&w=400&q=70&format=webp`}
                      alt=""
                      loading="lazy"
                      className="mb-4 shadow-lg w-full rounded-lg md:h-64 object-cover"
                    />
                    <div>
                      <h3 className="leading-[26px] font-normal text-[#74716d] text-[18px]">
                        {listing?.name}
                      </h3>
                      <p className="mt-2 font-thin text-[16px] text-[#74716d] leading-snug">
                        {truncateDescription(listing?.description, 12)}
                      </p>
                    </div>
                  </Link>
                ))
            )}
          </div>
        </div>
      </section> */}

      {locations.map((locationName, index) => {
        const isColored = index % 2 !== 0; // even = colored, odd = white (or vice versa)

        return (
          <section
            key={locationName}
            className={`py-10 pt-20 ${isColored ? "bg-[#fdfcf5]" : "bg-white"}`}
            id={locationName.toLowerCase().replace(/\s+/g, "_")}
          >
            <div className="container">
              <div className="flex items-center gap-4 mb-16">
                <img src={bluewaters} alt="" className="w-10" />
                <h2 className="text-[#74716d] font-thin lg:text-2xl md:text-2xl text-xl uppercase">
                  {locationName.toLowerCase() === "ebf"
                    ? "Emaar Beachfront"
                    : locationName}
                </h2>
              </div>

              <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-10">
                {loading ? (
                  <>
                    {[1, 2, 3].map((i) => (
                      <div key={i} className="flex w-full flex-col gap-4">
                        <div className="skeleton h-32 w-full"></div>
                        <div className="skeleton h-4 w-28"></div>
                        <div className="skeleton h-4 w-full"></div>
                        <div className="skeleton h-4 w-full"></div>
                      </div>
                    ))}
                  </>
                ) : (
                  listings
                    .filter(
                      (listing) =>
                        listing?.listingTags?.[0]?.name === locationName,
                    )
                    .map((listing) => (
                      <Link
                        to={`/listing/${listing.slug}`}
                        key={listing?.id}
                        className="hover:no-underline"
                      >
                        <img
                          src={`https://365luxuryhomes.com/api/listings/image?url=${encodeURIComponent(
                            listing?.listingImages?.[0]?.url,
                          )}&w=400&q=70&format=webp`}
                          alt=""
                          loading="lazy"
                          className="mb-4 shadow-lg w-full rounded-lg md:h-64 object-cover"
                        />
                        <div>
                          <h3 className="leading-[26px] font-normal text-[#74716d] text-[18px]">
                            {listing?.name}
                          </h3>
                          <p className="mt-2 font-thin text-[16px] text-[#74716d] leading-snug">
                            {truncateDescription(listing?.description, 12)}
                          </p>
                        </div>
                      </Link>
                    ))
                )}
              </div>
            </div>
          </section>
        );
      })}

      <div className="flex flex-col items-center justify-center lg:py-20 md:py-14 lg:mb-0 md:mb-0 mb-10">
        <a
          href="#banner"
          className="text-[#74716d] hover:no-underline hover:text-[#74716d]"
        >
          Go To Top
        </a>
        <div className="w-[2px] h-14 bg-[#aca9a5]"></div>
      </div>
    </div>
  );
};

export default Properties;
